goog.provide("shadow.js.shim.module$$embedpdf$plugin_selection");
goog.provide("module$shadow_js_shim_module$$embedpdf$plugin_selection");
shadow.js.shim.module$$embedpdf$plugin_selection = shadow.js.nativeProvides["@embedpdf/plugin-selection"] = shadow$bridge("@embedpdf/plugin-selection");
module$shadow_js_shim_module$$embedpdf$plugin_selection.default = shadow.js.shim.module$$embedpdf$plugin_selection;
